import {Card, Col, Row, Tabs, TabsProps, Typography} from 'antd';
import {useMemo, useState} from 'react';
import {MovingHistoryGeneralView} from './MovingHistoryGeneralView';
import {MovingHistoryByAssetView} from './MovingHistoryByAssetView';
import {capitalize} from "lodash";
import {useTranslation} from "react-i18next";
import EventHistoryDownloadButton from "./EventHistoryDownloadButton";
import EventNotes from "../eventNotes/EventNotes";

const {Title} = Typography;

enum EventMovingHistoryTabs {
  general = 'general',
  singleAsset = 'singleAsset',
  notes = 'notes'
}

export const EventMovingHistoryCard = (props: {}) => {

  const {t} = useTranslation();
  const [
    currentActiveTab,
    setCurrentActiveTab,
  ] = useState<EventMovingHistoryTabs>(EventMovingHistoryTabs.general);

  const items: TabsProps['items'] = useMemo(() => [
    {
      key: EventMovingHistoryTabs.general,
      label: capitalize(t('events.historyGeneral')),
    },
    {
      key: EventMovingHistoryTabs.singleAsset,
      label: capitalize(t('events.historyAsset')),
    },
    {
      key: EventMovingHistoryTabs.notes,
      label: capitalize(t('events.notes')),
    },
  ], [t]);

  return (
    <Card>
      <Row align={'middle'} justify={'space-between'}>
        <Col>
          <Title level={4} style={{marginTop: 0}}>
            {capitalize(t(currentActiveTab !== EventMovingHistoryTabs.notes ? 'events.changesHistory' : 'events.notes'))}
          </Title>
        </Col>
        <Col>
          <Tabs
            type={'card'}
            activeKey={currentActiveTab}
            items={items}
            onChange={(e) => setCurrentActiveTab(EventMovingHistoryTabs[e as keyof typeof EventMovingHistoryTabs])}
          />
        </Col>
      </Row>
      {currentActiveTab !== EventMovingHistoryTabs.notes && <Row style={{marginBottom: '2rem'}}>
        <Col>
          <EventHistoryDownloadButton/>
        </Col>
      </Row>}
      {currentActiveTab === EventMovingHistoryTabs.general && (
        <MovingHistoryGeneralView/>
      )}
      {currentActiveTab === EventMovingHistoryTabs.singleAsset && (
        <MovingHistoryByAssetView/>
      )}
      {currentActiveTab === EventMovingHistoryTabs.notes && (
        <EventNotes/>
      )}
    </Card>
  );
};